export const formatTheory = (text) => {
  if (!text) return "";

  // 1. Escape all HTML-sensitive characters
  let safeText = text
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");

  // 2. Restore only allowed custom tags
  return safeText
    .replaceAll("{{primary-text}}", `<p class="theory-primary">`)
    .replaceAll("{{/primary-text}}", "</p>")

    .replaceAll("{{secondary-text}}", `<p class="theory-secondary">`)
    .replaceAll("{{/secondary-text}}", "</p>")

    .replaceAll("{{third-text}}", `<p class="theory-third">`)
    .replaceAll("{{/third-text}}", "</p>")

    .replaceAll("{{sub-topic}}", `<div class="theory-subtopic">`)
    .replaceAll("{{/sub-topic}}", "</div>")

    .replaceAll("{{code}}", `<pre class="theory-code"><code>`)
    .replaceAll("{{/code}}", `</code></pre>`);
};
